import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserCardsCarouselComponent } from './user-cards-carousel.component';
import { NgxCarouselModule } from '../ngx-carousel/ngx-carousel.module';
import { CardCommentModule } from '../card-comment/card-comment.module';

@NgModule({
    declarations: [UserCardsCarouselComponent],
    exports: [UserCardsCarouselComponent],
    imports: [CommonModule, NgxCarouselModule, CardCommentModule],
    bootstrap: [UserCardsCarouselComponent]
})
export class UserCardsCarouselModule {}
